var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper pa-4"},[_c('h1',[_vm._v("threejs canvas截图")]),_vm._m(0),_c('p',[_vm._v(" 截图需要把render函数提出来 在截图前render函数执行一次 "),_c('canvas',{staticStyle:{"border":"1px solid","width":"100%","max-height":"20vh"},attrs:{"id":"c3"}}),_c('v-btn',{staticClass:"my-2",on:{"click":_vm.screenShotDownload}},[_vm._v(" 截图并下载 ")]),_c('v-btn',{staticClass:"my-2",on:{"click":_vm.screenShot}},[_vm._v(" 截图 ")]),_c('img',{staticStyle:{"display":"none"},attrs:{"id":"img","src":"","alt":"截图"}}),_c('highlightjs',{staticClass:"mt-4",attrs:{"code":`screenShotDownload() {
  const saveBlob = (function() {
  const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    return function saveData(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
    };
  }());

  this.render3();
  const canvas = document.getElementById('c3');
  canvas.toBlob((blob) => {
    saveBlob(blob, 'screencapture.png');
  });
},
screenShot() {
  this.render3();
  const canvas = document.getElementById('c3');
  const img = document.getElementById('img');
  const url = canvas.toDataURL();
  img.src = url;
  img.style.display = 'block';
},`,"language":'js'}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" 首先自适应宽度 根据canvas的实际宽高来渲染并不会导致失真 "),_c('canvas',{staticStyle:{"border":"1px solid","width":"100%","max-height":"20vh"},attrs:{"id":"c2"}})])
}]

export { render, staticRenderFns }